import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const DataTypeHeaderCell = ({ _customRowProps }: HeaderCellProps) => {
  return (
    <Tooltip title="Types of data that can be synced for this integration">
      <div>Data Type</div>
    </Tooltip>
  );
};

export default DataTypeHeaderCell;
